module.exports = __webpack_public_path__ + "img/block-love.f331b20e.jpg";